type RoofProps = { className?: string };

const ROOF_INK = {
  stroke: 'var(--outline)',
  strokeLinejoin: 'round' as const,
};

/**
 * The ridge over the tab bar: two minarets and three domes, drawn in the bar's
 * own colour so the two read as one shape.
 *
 * Every dome is drawn to fit inside the thirty units it has. The first version
 * used circular arcs whose radius equalled half the span, which makes a
 * semicircle fifty-seven units tall in a thirty-unit box — so the browser drew
 * the sides, clipped the top, and the masjid came out as a row of flat boxes.
 */
export function MasjidRoof({ className = '' }: RoofProps) {
  return (
    <svg
      className={`masjid-roof kids-only ${className}`.trim()}
      viewBox="0 0 390 30"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="var(--nav-bg)" strokeWidth="2.6" {...ROOF_INK}>
        <path d="M24 30V13q0-6 5-6t5 6v17Z" />
        <path d="M29 6V1" strokeLinecap="round" />
        <path d="M85 30C85 16.3 93.4 11 107 11C120.6 11 129 16.3 129 30Z" />
        <path d="M165 30C165 12 176.4 5 195 5C213.6 5 225 12 225 30Z" />
        <path d="M195 4V0" strokeLinecap="round" />
        <path d="M261 30C261 16.3 269.4 11 283 11C296.6 11 305 16.3 305 30Z" />
        <path d="M356 30V13q0-6 5-6t5 6v17Z" />
        <path d="M361 6V1" strokeLinecap="round" />
      </g>
    </svg>
  );
}

/**
 * The horizon on the entry screen: the same masjid with room to be itself —
 * taller minarets, a dome that carries a finial, and a wall with an arcade cut
 * into it. Its own viewBox rather than the ridge stretched to three times its
 * height, which would have thickened every horizontal stroke and left the
 * verticals thin.
 */
export function MasjidSkyline({ className = '' }: RoofProps) {
  return (
    <svg
      className={`masjid-skyline kids-only ${className}`.trim()}
      viewBox="0 0 390 96"
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="var(--cloud)" strokeWidth="2.8" {...ROOF_INK}>
        <path d="M24 96V44q0-11 8-11t8 11v52Z" />
        <path d="M32 32V18" strokeLinecap="round" />
        <path d="M350 96V44q0-11 8-11t8 11v52Z" />
        <path d="M358 32V18" strokeLinecap="round" />
        <path d="M0 96V78h390v18Z" />
        <path d="M66 78C66 50 76 38 96 38s30 12 30 40Z" />
        <path d="M264 78C264 50 274 38 294 38s30 12 30 40Z" />
        <path d="M151 78C151 34 166 18 195 18s44 16 44 60Z" />
        <path d="M195 17V4" strokeLinecap="round" />
      </g>
      <g fill="none" strokeWidth="2.4" {...ROOF_INK}>
        <path d="M150 96V88a8 8 0 0 1 16 0v8" />
        <path d="M187 96V88a8 8 0 0 1 16 0v8" />
        <path d="M224 96V88a8 8 0 0 1 16 0v8" />
      </g>
    </svg>
  );
}
